import { render } from "./CxFilterItem.vue?vue&type=template&id=2db4ae83"
import script from "./CxFilterItem.vue?vue&type=script&lang=js"
export * from "./CxFilterItem.vue?vue&type=script&lang=js"

import "./CxFilterItem.vue?vue&type=style&index=0&id=2db4ae83&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__